import { useIntl } from 'react-intl';

import { ActionsMenu } from '~/eds/src/components/ActionsMenu/ActionsMenu';
import { Button } from '~/eds/src/components/Button/Button';

type SaveAction = {
  tooltip?: string;
  disabled?: boolean;
  onClick: () => void;
};

interface Props {
  entity: 'Search' | 'Dashboard';
  overwriteAction?: SaveAction;
  saveAsNewAction: SaveAction;
}

export const SaveActionButton = ({
  entity,
  overwriteAction,
  saveAsNewAction,
}: Props) => {
  const intl = useIntl();
  const btnText =
    entity === 'Search'
      ? intl.formatMessage({
          id: 'SaveActionButton.saveButtonText.Search',
          defaultMessage: 'Save Search',
          description: 'Save button text with entity type',
        })
      : intl.formatMessage({
          id: 'SaveActionButton.saveButtonText.Dashboard',
          defaultMessage: 'Save Dashboard',
          description: 'Save button text with entity type',
        });

  const { tooltip, disabled, onClick } = overwriteAction ?? {};
  const {
    tooltip: saveAsNewTooltip,
    disabled: saveAsNewDisabled,
    onClick: onSaveAsNew,
  } = saveAsNewAction;

  return overwriteAction ? (
    <ActionsMenu
      triggerHeight="auto"
      trigger={
        <Button
          variant="secondary"
          icon="save"
          text={btnText}
          preset="dropdown"
        />
      }
      actions={[
        {
          label: intl.formatMessage(
            {
              id: 'SaveActionButton.saveAsNewLabel',
              defaultMessage: 'Save as a New {entity}',
              description:
                'Label for save as new action. Example: entity = "Search", "Dashboard"',
            },
            { entity },
          ),
          onClick: onSaveAsNew,
          tooltip: saveAsNewTooltip,
          disabled: saveAsNewDisabled,
          value: 'new',
        },
        {
          label: intl.formatMessage(
            {
              id: 'SaveActionButton.overwriteLabel',
              defaultMessage: 'Overwrite Saved {entity}',
              description:
                'Label for overwrite action. Example: entity = "Search", "Dashboard"',
            },
            { entity },
          ),
          value: 'overwrite',
          onClick,
          tooltip,
          disabled,
        },
      ]}
      name="save-search-menu"
      icon="chevron-down"
    />
  ) : (
    <Button
      variant="secondary"
      icon="save"
      iconPosition="left"
      text={btnText}
      disabled={saveAsNewDisabled}
      onClick={onSaveAsNew}
    />
  );
};
